import React from 'react'
import {connect} from 'react-redux'
import { Layout } from 'antd';
import { Navigate } from 'react-router';
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined
  } from '@ant-design/icons';
const { Header } = Layout;

function MainHeader(props){
    if(props.user.isAuthenticated !== true)
    {
         return <Navigate to='/' />
    }
    return (
     <Header 
            className="site-layout-background no-print" 
            style={{ padding: 0, color:'#ffffff', textAlign:'left', fontSize:'20px' }} 
            >
        {React.createElement(props.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger',
              onClick: props.toggle,
        })}
    </Header>
    )
}

const mapStateToProps = (state) => ({
    user:state.userReducer
})

const mapDispatchToProps = {
   
}

export default connect(mapStateToProps, mapDispatchToProps)(MainHeader)

